// extracted by mini-css-extract-plugin
export default {"sendModal":"TokenItem_sendModal__3yAsL","sendModalBg":"TokenItem_sendModalBg__2b68C","amountInput":"TokenItem_amountInput__0zQUc"};